interface RouteValue {
  path: string
  isProtected?: boolean
  backPath?: string
}

// Routes should not be protected - BE is validating them
const routes = {
  JOINT_HOME: {
    path: 'joint/', // Used for force-initiating a JOINT enrollment
  },
  SELECT_ACCOUNT: {
    path: 'select-account/',
  },
  ACCOUNT_TYPE: {
    path: 'joint/account-selection/',
  },
  CONTACT_INFO: {
    path: 'joint/get-started/',
  },
  HOME_ADDRESS: {
    path: 'joint/home-address/',
  },
  VERIFY_EMAIL: {
    path: 'joint/verify-email/',
  },
  VERIFY_PHONE: {
    path: 'joint/verify-phone/',
  },
  EMPLOYMENT: {
    path: 'joint/employment/',
  },
  FINANCES: {
    path: 'joint/finances/',
  },
  INVESTMENT_GOALS: {
    path: 'joint/investment-goals/',
  },
  CONFIRM_INFORMATION: {
    path: 'joint/confirm-information/',
  },
  SUITABILITY: {
    path: 'joint/bd-shareholder/',
  },
  DISCLOSURES: {
    path: 'joint/disclosures/',
  },
  CREATE_PASSKEY: {
    path: 'joint/create-passkey/',
  },
  WELCOME: {
    path: 'joint/welcome/',
  },
  WELCOME_V2: {
    path: 'joint/complete-joint-disclosures/',
  },
  MANUAL_REVIEW: {
    path: 'joint/manual-review/',
  },
  NEXT_STEP_DISCLOSURES: {
    path: 'joint/check-disclosures-link/',
  },
  VERIFY_IDENTITY: {
    path: 'joint/verify-identity',
  },
  REENTER_VERIFY_PHONE: {
    path: 'joint/reenter-verify-phone',
  },
  DOCUMENT_VERIFICATION: {
    path: 'joint/document-verification',
  },
  DOCUMENT_VERIFICATION_COMPLETE: {
    path: 'joint/document-verification-complete',
  },
  DECLINE: {
    path: 'joint/decline/',
  },
  //INTEGRATION:EnrollmentConst
} as const

// Record<string, RouteValue> doesn't suggest Route, so we need to define the following types to have keys suggested by TypeScript
type Routes = typeof routes
type RouteKey = keyof Routes
type Route = Record<RouteKey, RouteValue>
export const ROUTES = routes as Route
